import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Title from '../Title'

import HeaderPreviewBannerPhoto from './HeaderPreviewBannerPhoto'
import HeaderPreviewDetails from './HeaderPreviewDetails'

const useStyles = makeStyles(theme => ({
  header: {
    minHeight: '210px',
    width: '100%',
    display: 'flex',
    backgroundColor: ({ headerBackgroundColor }) => headerBackgroundColor,
    flexDirection: 'row',
    borderBottomRightRadius: '100px',
    overflow: 'hidden'
  }
}))

const HeaderPreview = ({ headerBackgroundColor, headerFontColor, accentColor, includeFreeInTitle }) => {
  const { t } = useTranslation()
  const classes = useStyles({
    headerBackgroundColor
  })

  return (
    <>
      <Title label={t('pages.accountSettings.services.remoteConsultation.setBannerPhoto')} optional />
      <div className={classes.header}>
        <HeaderPreviewDetails
          headerFontColor={headerFontColor}
          accentColor={accentColor}
          includeFreeInTitle={includeFreeInTitle}
        />
        <HeaderPreviewBannerPhoto />
      </div>
    </>
  )
}

export default HeaderPreview
